import { render } from "./App.vue?vue&type=template&id=aec0de76&scoped=true&style=background-color%3A%20%23ff4354"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/style.css?vue&type=style&index=0&id=aec0de76&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aec0de76"]])

export default __exports__